import { useState } from 'react';
import { validateForm } from './formValidations';
import GetTouch from './GetTouch';
import ContactForm from './ContactForm';
import Popup from '../../utils/Popup';

const Contact = () => {
  const formInitialDetails = {
    name: '',
    email: '',
    subject: '',
    message: '',
  };
  const [formDetails, setFormDetails] = useState(formInitialDetails);
  const [buttonText, setButtonText] = useState('SEND MESSAGE');
  const [showPopup, setShowPopup] = useState(false);
  const [popupSuccess, setPopupSuccess] = useState(false);
  const [isCaptchaVerified, setIsCaptchaVerified] = useState(false);
  const [errors, setErrors] = useState({});

  const onFormUpdate = (category, value) => {
    setFormDetails({
      ...formDetails,
      [category]: value,
    });
  };

  const handleSubmit = async e => {
    try {
      e.preventDefault();

      if (!isCaptchaVerified) {
        setErrors({ captcha: 'Please complete the reCAPTCHA verification' });
        return;
      }

      // Clear previous errors
      setErrors({});

      const formErrors = validateForm(formDetails);
      if (Object.keys(formErrors).length > 0) {
        setErrors(formErrors);
        return;
      }

      setButtonText('Sending...');

      // Use API URL from env or default to relative path
      const apiUrl = process.env.REACT_APP_API_URL || '/api';
      
      // Check if fetch is available (fallback for very old browsers)
      if (typeof fetch === 'undefined') {
        throw new Error('Your browser does not support this feature. Please update your browser.');
      }
      
      const response = await fetch(apiUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${process.env.REACT_APP_TOKEN}`,
        },
        body: JSON.stringify(formDetails),
      });

      let data;
      try {
        data = await response.json();
      } catch (parseError) {
        throw new Error('Invalid response from server');
      }

      if (response.ok && data.success) {
        setPopupSuccess(true);
        setFormDetails(formInitialDetails);
        setIsCaptchaVerified(false);
      } else {
        setPopupSuccess(false);
        setErrors({ 
          submit: data.message || 'Failed to send message. Please try again.' 
        });
      }
      
      setShowPopup(true);
      setButtonText('SEND MESSAGE');
    } catch (err) {
      console.error('Error: ', err);
      setButtonText('SEND MESSAGE');
      setPopupSuccess(false);
      setErrors({ 
        submit: 'Network error. Please check your connection and try again.' 
      });
      setShowPopup(true);
    }
  };

  const handleClosePopup = () => setShowPopup(false);
  const handleRecaptchaChange = () => setIsCaptchaVerified(true);

  return (
    <section className="contactus mt-5" id="connect">
      {showPopup && <Popup success={popupSuccess} onClose={handleClosePopup} />}
      <div className="container position-relative">
        <div className="row d-flex flex-wrap">
          <div className="col-sm-12 col-md-12 col-lg-6">
            <GetTouch />
          </div>
          <ContactForm
            handleSubmit={handleSubmit}
            formDetails={formDetails}
            onFormUpdate={onFormUpdate}
            errors={errors}
            handleRecaptchaChange={handleRecaptchaChange}
            buttonText={buttonText}
            isVerified={isCaptchaVerified}
          />
        </div>
      </div>
    </section>
  );
};

export default Contact;
